import React from "react";
import { Persona } from "@soulmachines/smwebsdk";
import Carousel from "react-multi-carousel";

import "react-multi-carousel/lib/styles.css";
import { detectDeviceType } from "../../../utils/detectDeviceType";
import { CharacterSelectionTypes } from "../../../types/ContentCard";

import { CharacterSelectionContainer } from "./CharacterSelectionStyles";
import { isMobileOnly } from "react-device-detect";

const CharacterSelection: React.FC<{
  contentCardData: CharacterSelectionTypes;
  tabletLandscape: boolean;
  persona: Persona;
  dispatch: Function;
  active: Boolean;
}> = ({ contentCardData, tabletLandscape, persona, dispatch, active }) => {
  const detectLayout = () => {
    if (isMobileOnly) {
      return (
        <CharacterSelectionContainer
          deviceType={detectDeviceType()}
          isLandscape={tabletLandscape}
          data-sm-content="characters"
        >
          <h1>{contentCardData.data.title}</h1>
          <div
            style={{
              marginTop: "12px",
              paddingBottom: "25px",
              position: "relative",
            }}
          >
            <Carousel
              additionalTransfrom={0}
              autoPlaySpeed={10000000}
              arrows={false}
              centerMode={false}
              containerClass="container"
              draggable
              minimumTouchDrag={80}
              renderButtonGroupOutside={false}
              renderDotsOutside
              focusOnSelect
              dotListClass="dot"
              // customDot={<div className="dot" />}
              responsive={{
                mobile: {
                  breakpoint: {
                    max: 464,
                    min: 0,
                  },
                  items: 1,
                  partialVisibilityGutter: 30,
                },
              }}
              showDots
              slidesToSlide={1}
              swipeable
            >
              {contentCardData.data.characters.map((characters, index) => {
                return (
                  <div key={index} className="characters-card">
                    <img
                      src={characters.pictureUrl}
                      alt={characters.pictureAlt}
                    />
                    <h4>{characters.buttonValue}</h4>
                    {/* Forgive me Father, I have sinned */}
                    <p
                      dangerouslySetInnerHTML={{ __html: characters.plaintext }}
                    />
                    <button
                      className="selection"
                      type="button"
                      disabled={!active}
                      onClick={() => {
                        persona.conversationSend(
                          characters.buttonValue,
                          {},
                          {}
                        );
                        dispatch({
                          type: "ADD_CONVERSATION_MESSAGE",
                          payload: {
                            source: "user",
                            text: characters.buttonValue,
                          },
                        });
                      }}
                    >
                      {characters.buttonText}
                    </button>
                  </div>
                );
              })}
            </Carousel>
          </div>
        </CharacterSelectionContainer>
      );
    }
    return (
      <CharacterSelectionContainer
        deviceType={detectDeviceType()}
        isLandscape={tabletLandscape}
        data-sm-content="characters"
      >
        <h1>{contentCardData.data.title}</h1>
        <div>
          {contentCardData.data.characters.map((characters, index) => {
            return (
              <div key={index} className="characters-card">
                <img src={characters.pictureUrl} alt={characters.pictureAlt} />
                <h4>{characters.buttonValue}</h4>
                {/* Forgive me Father, I have sinned */}
                <p dangerouslySetInnerHTML={{ __html: characters.plaintext }} />
                <button
                  disabled={!active}
                  className="selection"
                  type="button"
                  onClick={() => {
                    persona.conversationSend(characters.buttonValue, {}, {});
                    dispatch({
                      type: "ADD_CONVERSATION_MESSAGE",
                      payload: {
                        source: "user",
                        text: characters.buttonValue,
                      },
                    });
                  }}
                >
                  {characters.buttonText}
                </button>
              </div>
            );
          })}
        </div>
      </CharacterSelectionContainer>
    );
  };
  return detectLayout();
};

export default CharacterSelection;
